import { ResolveFn } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { inject } from '@angular/core';
import { User } from '../../../core/classes/user';

export const userResolver: ResolveFn<User> = (route) => {
  const userId = route.params['id'] || 0;
  return inject(UserService)
    .getUserById(userId);
};
